import styled from 'styled-components';

import { colors, fonts, fontSizes } from 'shared/defaultTheme';

import { Modal } from '../modal/Modals';

const ConfirmModalWrapper = styled(Modal)`
  top: 20%;
  .modal-header {
    border: 0;
    border-radius: 0;
    svg {
      fill: ${colors.white};
    }
    .icon-title {
      height: 38px;
      width: 38px;
    }
  }
  .no-show-message {
    color: ${colors.suvaGrey};
  }
`;

const ConfirmMessage = styled.label`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: ${fontSizes.md}px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
`;

const ConfirmMessages = styled.label`
  color: ${colors.black};
  font-family: ${fonts.default};
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 20px;
`;

export { ConfirmModalWrapper, ConfirmMessage, ConfirmMessages };
